import { getLocalStorage, setLocalStorage, CookieConsent } from "@trustpilot/businessapp-browserstorage";
import { Modal } from "@trustpilot/businessapp-patternlibrary";
import { Text } from "ilenia";
import React from "react";

import { trackingConst } from "../../constants";
import { useAnalytics } from "../../utils/analytics";
import { changeBusinessUnit, setSessionStorage } from "../../utils/changeAccount";
import { localStorageKeys } from "../constants";
import AccountsList from "./accountsList";
import AlwaysShowAtLoginToggle from "./alwaysShowAtLoginToggle";
import * as Types from "./types";
import { hideSelectorModal } from "./utils";

export const AccountSelector: React.FC<Types.AccountSelector> = ({ allAccounts, onCloseAccountSelector }) => {
  const analytics = useAnalytics();

  const [isOpen, setOpen] = React.useState<boolean>(false);
  const [showOnLogin, setShowOnLogin] = React.useState<boolean>(true);

  React.useEffect(() => {
    const localStorageKeysContext = localStorageKeys.accountselector.context;
    const localStorageHideSelectorModal = localStorageKeys.accountselector.names.hideSelectorModal;
    const userHasDisableModal =
      getLocalStorage(localStorageKeysContext, localStorageHideSelectorModal) ||
      sessionStorage.getItem(`${localStorageKeysContext}-${localStorageHideSelectorModal}`);

    if (
      allAccounts &&
      allAccounts.length > 1 &&
      !userHasDisableModal &&
      !window.location.search.toLocaleLowerCase().includes("businessunitid")
    ) {
      setOpen(true);
    } else {
      onCloseAccountSelector();
    }
  }, [allAccounts]);

  const close = React.useCallback(() => {
    setOpen(false);
    onCloseAccountSelector();
    setSessionStorage();
    hideSelectorModal(showOnLogin, setLocalStorage);
  }, [showOnLogin]);

  return (
    isOpen && (
      <Modal
        isOpen={isOpen}
        header={<Text id="account-selector.choose_an_organization" />}
        onClose={close}
        mainActionButton={{
          buttonText: "",
        }}
        tertiaryActionArea={() => (
          <AlwaysShowAtLoginToggle
            showOnLogin={showOnLogin}
            setShowOnLogin={(showOnLogin) => setShowOnLogin(showOnLogin)}
          />
        )}
      >
        <AccountsList
          businessAccounts={allAccounts}
          onAccountSelected={(account) => {
            const {
              id,
              name,
              businessUnits: [firstUnit],
            } = account;

            CookieConsent.hasCategoryConsent("C0002")
              .then((hasTrackingConsent) => {
                if (hasTrackingConsent) {
                  analytics.track(trackingConst.events.accountSelected, {
                    context: trackingConst.contexts.accountSelectorModal,
                    account: {
                      id,
                      name,
                    },
                  });
                }
              })
              .finally(() => {
                close();
                changeBusinessUnit(firstUnit);
              });
          }}
        />
      </Modal>
    )
  );
};
